import styled from 'styled-components'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { Box, Column, Row } from '@shipt/design-system-layouts'
import { Body, Headline } from '@shipt/design-system-typography'
import { ButtonLink } from '@/features/shared/elements/Link/Buttons'
import { routes } from '@shared/constants/routes'
import { type PlaceholderData } from '@/features/cms/components/CMS/types'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import { screenSizes } from '@shipt/design-system-themes'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { useEffect } from 'react'
import { useCMSTrackingEvents } from '@/features/cms/components/CMS/CMSContext'
import { theme } from '@/features/shared/constants/shiptTheme'

export const HomepageHeroBanner = ({ id, content_type_id }: PlaceholderData) => {
  const { trackCMSElementViewed, trackCMSElementClicked } = useCMSTrackingEvents()

  useEffect(() => {
    trackCMSElementViewed({
      type: 'banner',
      content: 'mhp_hero_banner',
    })
  }, [trackCMSElementViewed])

  const handleClick = () => {
    trackCMSElementClicked({
      display_sublocation: 'mhp_hero_banner',
      content: 'start_shopping',
      type: 'link',
    })
  }

  return (
    <Container {...getCMSWrapperProps({ content_type_id, id })}>
      <Row align="center" justify="space-between" spacing="md">
        <Column padding={{ base: ['lg', 0], md: ['xxl', 0] }} spacing="lg">
          <div>
            {/* "Same-day delivery" must always be the h1 for SEO but we
            do not want it to be the main focus of the page */}
            <Body size="md" as="h1" variant="secondary">
              Same-day delivery
            </Body>
            <Box display={{ base: 'none', md: 'block' }}>
              <Headline size="xl" as="h2">
                Groceries and more, <br />
                delivered from stores you love
              </Headline>
            </Box>
            <Box display={{ base: 'block', md: 'none' }}>
              <Headline size="md" as="h2">
                Groceries and more, <br />
                delivered from stores you love
              </Headline>
            </Box>
          </div>
          <CallToAction
            onClick={handleClick}
            size={{ base: 'md', sm: 'lg' }}
            href={routes.GLOBAL_HOMEPAGE.url}
          >
            Start shopping
          </CallToAction>
        </Column>
        <ImageWeb
          src={objectStorageUrl('hero-SKB-dweb.webp')}
          alt=""
          fetchPriority="high"
          width={450}
          height={250}
          quality={100}
        />
        <ImageMobile
          src={objectStorageUrl('hero-SKB-mweb.webp')}
          alt=""
          fetchPriority="high"
          width={120}
          height={120}
          quality={100}
        />
      </Row>
    </Container>
  )
}

const Container = styled(GridLayoutContainer)`
  background: ${theme.color.background.base.brand.secondary};
`

const CallToAction = styled(ButtonLink)`
  align-self: start;
`

const ImageWeb = styled(Image)`
  @media ${screenSizes.max_mobile} {
    display: none;
  }
`

const ImageMobile = styled(Image)`
  padding: 1rem 0;

  @media ${screenSizes.tablet} {
    display: none;
  }
`
